// Stripe Configuration
// Similar to firebase.js and spotify.js, configuration is hardcoded

// TEST mode configuration
// const stripeTestConfig = {
//   publishableKey: 'pk_test_51SDPeRKGrWq14XZrgPPQGC9NAu1KXSYiOYeTPq4kCRQNonfrAPN2lqtl7BwtwEnom0BLXhETA4jXjTZ4QzyaoqbQ00Hs4aI3b4',
//   priceId: 'price_1SGOvsKGrWq14XZrWgdWGmIn',
//   successUrl: 'http://localhost:3000/subscription-success',
//   cancelUrl: 'http://localhost:3000/subscription-cancel'
// };

// LIVE mode configuration
const stripeLiveConfig = {
  publishableKey: 'pk_live_51SE5Lz2KHxI39fZOAi0WkHZLQ6L53dp6yKUj7qxvfMnLudqcqRlEmAoOVurHY6zApi8QffbPj71T4WehyLN7uRRV00BghMhXTk',
  priceId: 'price_1SGjGY2KHxI39fZOATpIUxPo',
  successUrl: 'https://songcarousel.com/subscription-success?session_id={CHECKOUT_SESSION_ID}',
  cancelUrl: 'https://songcarousel.com/subscription-cancel'
};

// Toggle between TEST and LIVE by commenting/uncommenting
// Follows the same pattern as reducer.js database switching

// TEST MODE (uncomment for testing)
export const stripeConfig = stripeLiveConfig;

// LIVE MODE (uncomment for production)
// export const stripeConfig = stripeLiveConfig;

// Subscription tiers configuration
export const subscriptionTiers = {
  free: {
    name: 'Free',
    listeningTimeRequired: 44, // seconds before rating
    maxVisibleRatings: 2, // only see latest 2 ratings
    songsToRateBeforeUpload: 5, // must rate 5 songs before upload
  },
  premium: {
    name: 'Premium',
    listeningTimeRequired: 34, // seconds before rating
    maxVisibleRatings: -1, // unlimited (-1 means no limit)
    songsToRateBeforeUpload: 4, // must rate 4 songs before upload
    monthlyPrice: '$2.99' // for display purposes
  }
};

// Portal configuration URL (will be set up in Stripe Dashboard)
export const customerPortalUrl = 'https://billing.stripe.com/p/login/4gMbIU5vd0hy7IB42O67S00';